export const LIST_INITIAL_SOAP = "LIST_INITIAL_SOAP"
export const CHANGE_STATUS_MODAL_SOAP = "CHANGE_STATUS_MODAL_SOAP"
export const CHANGE_LIST_SOAP = "CHANGE_LIST_SOAP"